import { useApiSend } from '../../../shared/api/utils/reactQueryProvider';
import { removeRiders } from '../../api/services/Rides';
import { RemoveRidersPayload } from '../../types/rides';

interface IUseRemoveRidersSubmit {
  rideSlug: string;
  successCallback?: (data) => void;
  errorCallback?: (
    error:
      | Error & {
          errors: string[];
        }
  ) => void;
}

export const useRemoveRidersSubmit = ({ rideSlug, successCallback, errorCallback }: IUseRemoveRidersSubmit) => {
  return useApiSend(
    (payload: RemoveRidersPayload) => removeRiders(rideSlug, payload),
    successCallback,
    errorCallback,
    [],
    undefined
  );
};
